// In-game injury on the leg: orange "HURT" first, flashing red once he's ruled out for the rest of the game.
export const gameInjuryOut = (l) => l.game_injury?.stage === 'out' && !l.game_injury?.final;
export const ticketHasOut = (t) => (t.legs || []).some(gameInjuryOut);

export const GameInjuryBar = ({ leg, big = false, onClick }) => {
  const gi = leg.game_injury;
  if (!gi?.stage || gi.final) return null;
  const out = gi.stage === 'out';
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      className={`relative z-20 mt-0.5 block w-full text-left rounded px-1 font-black truncate ${big ? 'text-[11px] leading-5 py-0.5' : 'text-[9px] leading-4'} ${out ? 'bg-red-600 text-white animate-pulse shadow-[0_0_10px_rgba(239,68,68,0.8)]' : 'bg-orange-500 text-black'}`}
      title={`${gi.text}${gi.clock ? ` · ${gi.clock}` : ''} · ${gi.source} — tap for details`} data-testid={`game-injury-${leg.id}`} data-stage={gi.stage}>
      {out ? '✚ OUT FOR THE GAME' : '✚ HURT — may not return'}{gi.clock ? ` · ${gi.clock}` : ''}
    </button>
  );
};
